<script setup lang="ts">
import { cn } from 'cn'
import { computed, type HTMLAttributes } from 'vue'
import { type PrimitiveProps, SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui'

import { injectSelectContext } from './Select.vue'
import { selectTriggerIconVariants, selectTriggerVariants, type SelectTriggerVariants } from './variants'

export interface Props extends PrimitiveProps {
  size?: SelectTriggerVariants['size']
  class?: HTMLAttributes['class']
  hasError?: boolean
  omitIcon?: boolean
}

const props = withDefaults(defineProps<SelectTriggerProps & Props>(), {
  size: 'md',
})

const { hasError: hasInjectedError } = injectSelectContext()
const hasError = computed(() => props.hasError || hasInjectedError.value)

const delegatedProps = computed(() => {
  const { class: _, omitIcon: _1, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    :class="cn(
      selectTriggerVariants({ size, hasError }),
      props.class,
    )"
  >
    <slot />
    <SelectIcon
      v-if="!omitIcon"
      as-child
    >
      <UiIcon
        name="docue:chevron-down"
        :class="cn(selectTriggerIconVariants({ size }))"
      />
    </SelectIcon>
  </SelectTrigger>
</template>
